import context from '@/providers/audio/audioContext';
import { useContext } from 'react';

export default function useAudio() {
  const value = useContext(context);
  if (value === undefined) {
    throw new Error('some thing error');
  }

  return value;
}
